"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagET = function FlagET(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.55,12.26A84.76,84.76,0,1,1,11.8-72.57,84.79,84.79,0,0,1,96.55,12.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-52.66-9H-3.42L7.72-43.34l3,9.19L-5.5,15.71l-4.82-3.52,5-15.49h-39.6Zm24.6,75.83L-12.84,20-42-1.27h9.62L10,29.51,5.19,33-8,23.42-20.28,61.16Zm79.72,0L11.8,37.83-17.35,59l3-9.06L28,19.09l1.81,5.68L16.62,34.31l32,23.34ZM76.26-9,36.44,20,47.58,54.26,39.8,48.58,23.64-1.27h5.91l5,15.56L66.66-9ZM11.8-55.86,27-9H63.09L55.29-3.3H2.91L4.75-9H21.08L8.82-46.73Zm0,0",
    transform: "translate(194 123)",
    fill: "#f2dd30"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.22,80H10.39V43.31h2.83Zm62.62-45.6L40.92,23.15l.88-2.64,34.94,11.3Zm-128.1,0-.88-2.63,35-11.3.86,2.64ZM31.23-12.09l-2.3-1.63,21.6-29.69,2.24,1.62Zm-38.81,0-21.63-29.7,2.28-1.62L-5.35-13.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#f2dd30"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagET;
exports["default"] = _default;